(() => {
  const destroyTicker = (tickerEl) => {
    tickerEl._featureCardHold?.destroy();
    tickerEl._featureCardHold = null;

    if (tickerEl.swiper) {
      tickerEl.swiper.destroy(true, true);
    }
  };

  const initFeatureCardMediaTicker = (section) => {
    if (!section) return;

    const tickers = section.querySelectorAll(".js-feature-card-media-ticker");
    if (tickers.length === 0) return;

    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    tickers.forEach((tickerEl) => {
      destroyTicker(tickerEl);

      const slideEls = tickerEl.querySelectorAll(
        ".feature-card__feature-media-list-item"
      );
      if (slideEls.length < 2) return;

      const isOverBackground = !!tickerEl.closest(
        ".feature-card__feature-media--over-background"
      );

      new Swiper(tickerEl, {
        speed: 12000,
        slidesPerView: "auto",
        spaceBetween: isOverBackground ? 0 : 16,
        autoplay: reduceMotion
          ? false
          : {
              delay: 0,
              disableOnInteraction: false,
              pauseOnMouseEnter: false,
            },
        watchSlidesProgress: true,
        loop: true,
        loopedSlides: slideEls.length,
        freeMode: false,
        shortSwipes: false,
        longSwipes: false,
        allowTouchMove: false,
        simulateTouch: false,
        a11y: {
          scrollOnFocus: false,
        },
      });

      if (reduceMotion || !tickerEl.swiper) return;

      const holdRoot = tickerEl.closest(".feature-card") || tickerEl;
      tickerEl._featureCardHold = holdSwiperAutoplay(
        tickerEl.swiper,
        holdRoot,
        {
          hoverTarget: holdRoot,
          freeze: true,
        }
      );
    });
  };

  const destroyFeatureCardMediaTicker = (section) => {
    if (!section) return;

    section
      .querySelectorAll(".js-feature-card-media-ticker")
      .forEach(destroyTicker);
  };

  initFeatureCardMediaTicker(document.currentScript.parentElement);

  if (!window.__themeFeatureCardsTickerEvents) {
    window.__themeFeatureCardsTickerEvents = true;

    document.addEventListener("shopify:section:load", function (event) {
      initFeatureCardMediaTicker(event.target);
    });

    document.addEventListener("shopify:section:reorder", function (event) {
      initFeatureCardMediaTicker(event.target);
    });

    document.addEventListener("shopify:block:update", function (event) {
      const section = event.target.closest(".feature-cards-section");
      if (!section) return;
      initFeatureCardMediaTicker(section);
    });

    document.addEventListener("shopify:section:unload", function (event) {
      destroyFeatureCardMediaTicker(event.target);
    });
  }
})();
